import BenefitPreviews from './BenefitPreviews'

export default BenefitPreviews
